import '../styles/NomArea.css';

function NomArea() {
    return (
        <h2 className="nom-area">Informática</h2>
    );
}

export default NomArea;